module.exports = __webpack_public_path__ + "static/media/T14-T25-04.4c5d79b2.svg";